import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import TiktokPixel from "tiktok-pixel";
import { hasTargetingConsent, isAnalyticsStarted } from "./consent";

const TIKTOK_PIXEL_ID = "CQOFVN3C77U11VCBB9AG";

export default function AnalyticsRouteTracker() {
  const loc = useLocation();
  const lastPathRef = useRef(null);
  const tiktokStartedRef = useRef(false);

  useEffect(() => {
    const path = loc.pathname + loc.search;
    const url = window.location.href;

    // avoid duplicate fires if the router re-renders without path change
    if (lastPathRef.current === path) return;
    lastPathRef.current = path;

    // Meta / Reddit / Google Ads, already consent-gated by OneTrust
    if (typeof window.__trackPage === "function") {
      window.__trackPage({ path, url });
      // console.log("tracked", path, url);
    }

    // Tags loaded from React gate themselves on targeting consent (C0004)
    if (!hasTargetingConsent()) return;

    if (isAnalyticsStarted()) {
      ReactGA.send({ hitType: "pageview", page: path, location: url });
    }

    // init once, then a pageview per route change
    if (!tiktokStartedRef.current) {
      TiktokPixel.init(TIKTOK_PIXEL_ID);
      tiktokStartedRef.current = true;
    }

    TiktokPixel.pageView();
    // console.log("tiktok pageview");
  }, [loc.pathname, loc.search]);

  return null;
}
